var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentEntityIntro } from './content-entity-intro';
import { DownloadButton } from '../elements/download-button';
import { CellLabel } from '../elements/cell-label';
import { ContentNode } from './content-node';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('page-view-layout');
export var PageViewLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme.UNIT(4))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    margin-bottom: ", ";\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(5), theme.UNIT(5))
});
var IntroStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.65em;\n  "], ["\n    font-weight: 500;\n    font-size: ", "em;\n    line-height: 1.65em;\n  "])), 15 / 14)
});
var ContentLabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.COLOR('text-mid'))
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: ", "em;\n  "], ["\n    font-weight: 300;\n    font-size: ", "em;\n  "])), 15 / 14)
});
var DownloadButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 460px;\n  "], ["\n    max-width: 460px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Section: styled.section(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Intro: styled(ContentEntityIntro)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  DownloadButton: styled(DownloadButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DownloadButtonStyles),
  ContentLabel: styled(CellLabel)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContentLabelStyles),
  Content: styled(ContentNode)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var PageViewLayout = function (props) {
  var _a = useComponentPropsFor('PageViewLayout', PageViewLayoutDefaultProps, props),
    className = _a.className,
    children = _a.children,
    afterIntro = _a.afterIntro,
    entity = _a.entity;
  ;
  var content = entity.content;
  var hasAfterIntro = !!afterIntro;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.Section, null, React.createElement(My.Intro, {
    entity: entity
  }), hasAfterIntro && afterIntro), React.createElement(My.Section, null, React.createElement(My.Content, {
    entity: content
  })), children));
};
PageViewLayout.defaultProps = PageViewLayoutDefaultProps;
PageViewLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;